module.exports = __webpack_public_path__ + "fonts/iconfont.ac0a05f5.ttf";